import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Article from "@/pages/article/page";
import QcGuide from "@/pages/qc-guide/page";
import ShippingGuide from "@/pages/shipping-guide/page";
import AgentComparison from "@/pages/agent-comparison/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul/kakobuy-sheet-kompletny-przewodnik",
    element: <Article />,
  },
  {
    path: "/artykul/kakobuy-qc-guide",
    element: <QcGuide />,
  },
  {
    path: "/artykul/kakobuy-wysylka-do-polski",
    element: <ShippingGuide />,
  },
  {
    path: "/artykul/kakobuy-porownanie-agentow",
    element: <AgentComparison />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;